<script lang="ts">
	import Action from '../action/Action.svelte'
	import Icon from '../icon/Icon.svelte'
	import { ToastType } from './index'
	import { type ToastMessage, toasts } from './toasts'
	import { _ } from '@repo/i18n'
	import { CheckCircle, ExclamationTriangle, XCircle, XMark } from '@steeze-ui/heroicons'

	interface Props {
		toast: ToastMessage
	}

	let { toast }: Props = $props()

	function close() {
		toasts.remove(toast.id)
	}

	let isError = $derived(toast.type === ToastType.error)
	let isWarn = $derived(toast.type === ToastType.warning)
</script>

<div
	class="shadow-toast relative rounded-xl bg-white p-4 pr-8 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-200"
	aria-live="assertive"
	data-test={isError ? 'toast-error' : 'toast-success'}
>
	<div class="flex items-center space-x-3">
		<div
			class="flex shrink-0 self-start {isError
				? 'text-red-500'
				: isWarn
					? 'text-yellow-400'
					: 'text-green-400'}"
		>
			<Icon src={isError ? XCircle : isWarn ? ExclamationTriangle : CheckCircle} />
		</div>
		<div class="w-full flex-1 space-y-1 truncate">
			<div
				class="truncate font-bold {isError
					? 'text-red-900 dark:text-red-500'
					: isWarn
						? 'text-yellow-900 dark:text-yellow-500'
						: 'text-gray-800 dark:text-white'}"
				data-test="toast-content"
			>
				{$_(toast.title)}
			</div>
			{#if toast.text || toast.html}
				<div class="whitespace-normal">
					{#if toast.html}
						<!-- eslint-disable-next-line svelte/no-at-html-tags -->
						{@html toast.html}
					{:else}
						{$_(toast.text)}
					{/if}
				</div>
			{/if}
		</div>
	</div>

	<div class="absolute top-4 right-4 text-gray-400">
		<Action name="close-toast" ariaLabel={$_('button.close')} onclick={close}>
			<Icon small src={XMark} />
		</Action>
	</div>
</div>
